// User role enum to match backend implementation
export enum UserRole {
  ADMIN = 'admin',
  FINANCE = 'finance',
  STAFF = 'staff'
}

// User status enum
export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended'
}

// Permission constants
export const PERMISSIONS = {
  // Lead permissions
  LEAD_VIEW: 'lead:view',
  LEAD_CREATE: 'lead:create',
  LEAD_EDIT: 'lead:edit',
  LEAD_DELETE: 'lead:delete',
  LEAD_CLAIM: 'lead:claim',
  LEAD_RELEASE: 'lead:release',

  // Case permissions
  CASE_VIEW: 'case:view',
  CASE_CREATE: 'case:create',
  CASE_EDIT: 'case:edit',
  CASE_DELETE: 'case:delete',
  CASE_ASSIGN: 'case:assign',

  // User management permissions
  USER_VIEW: 'user:view',
  USER_CREATE: 'user:create',
  USER_EDIT: 'user:edit',
  USER_DELETE: 'user:delete',

  // System permissions
  SYSTEM_CONFIG: 'system:config',
  SYSTEM_EXPORT: 'system:export',
  SYSTEM_IMPORT: 'system:import',

  // Admin permissions
  ADMIN_ALL: '*'
} as const;

// Helper function to check if role has admin privileges
export const isAdminRole = (role: string): boolean => {
  return role === UserRole.ADMIN;
};

// Helper function to get role display name
export const getRoleDisplayName = (role: UserRole): string => {
  const roleNames: Record<UserRole, string> = {
    [UserRole.ADMIN]: '管理员',
    [UserRole.FINANCE]: '财务',
    [UserRole.STAFF]: '员工'
  };
  return roleNames[role] || role;
};

// Helper function to get status display name
export const getStatusDisplayName = (status: UserStatus): string => {
  const statusNames: Record<UserStatus, string> = {
    [UserStatus.ACTIVE]: '正常',
    [UserStatus.INACTIVE]: '停用',
    [UserStatus.SUSPENDED]: '暂停'
  };
  return statusNames[status] || status;
};